interface Config {
  amplitude?: string;
  api: string;
  onlineApi: string;
  clerk: string;
  fullstory?: string;
}

const config: Config =
  process.env.NODE_ENV === "production"
    ? {
        amplitude: "a1373bdad6293ab1edee01f68cc90540",
        api: "https://v2.youka.io/api",
        onlineApi: "https://online.youka.io/api/trpc",
        clerk: "pk_live_Y2xlcmsueW91a2EuaW8k",
        fullstory: "o-1VV1TE-na1",
      }
    : {
        api: "http://localhost:4000/api",
        onlineApi: "http://localhost:3003/api/trpc",
        clerk: "pk_test_YXB0LXNsb3RoLTcwLmNsZXJrLmFjY291bnRzLmRldiQ",
      };

export default config;
